import React, { useEffect, useState } from "react";
import AdminLayout from "./AdminLayout";
import { endpoints, Image_BASE_URL } from "../_config";
import { get } from "../_services/apiService";
import { Link } from "react-router-dom";
import HotelSurvey from "./HotelSurvey";
import ReviewByLocation from "./ReviewByLocation";
import GradientLineChart from "./GradientLineChart ";
import DashboardLineChart from "./DashboardBarChart ";
import LocationMapping from "./LocationMapping";

const DashboardInnerPage = () => {
    const [appointmentData, setAppointmentData] = useState([]);
    const [quatationData, setQuatationData] = useState([]);
    const [clubMembership, setClubMembership] = useState([]);
    const [enquiryData, setEnquiryData] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    const GetBookAppoinment = async () => {
        try {
            const response = await get(endpoints.GetBookAppoinment)
            if (response.isSuccess === 200) {
                setAppointmentData(response.data);
            } else {
                setError("Failed to fetch Service Type");
            }
        } catch (error) {
            setError("Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    const GetQuatation = async () => {
        try {
            const response = await get(endpoints.GetQuatation)
            if (response.isSuccess === 200) {
                setQuatationData(response.data);
            } else {
                setError("Failed to fetch Service Type");
            }
        } catch (error) {
            setError("Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    const GetClubMembership = async () => {
        try {
            const response = await get(endpoints.GetClubMembership)
            if (response.isSuccess === 200) {
                setClubMembership(response.data);
            } else {
                setError("Failed to fetch Service Type");
            }
        } catch (error) {
            setError("Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    const GetEnquiry = async () => {
        try {
            const response = await get(endpoints.GetEnquiry)
            if (response.isSuccess === 200) {
                setEnquiryData(response.data);
            } else {
                setError("Failed to fetch Service Type");
            }
        } catch (error) {
            setError("Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        GetQuatation();
        GetBookAppoinment();
        GetClubMembership();
        GetEnquiry();
    }, []);

    return (

        <AdminLayout  >
            <div className="container-fluid">
                <div className="dashboard_add_quotation_wepper">
                    <div className="row justify-content-center" >
                        <div className="col-xxl-3 col-lg-6 col-md-4 col-sm-6"><Link to="/admin/appointments">
                            <div className="shadow_box_wrapper pink_bg">
                                <span className="icon_wrapper"><i className="fa fa-calendar-alt"></i><p className="mt-2">Appointments</p></span>
                                <span className="conut_wrapper">
                                    {appointmentData?.length}
                                </span>
                            </div>
                        </Link>
                        </div>
                        <div className="col-xxl-3 col-lg-6 col-md-4 col-sm-6"><Link to="/admin/quotationlist">
                            <div className="shadow_box_wrapper yellow_bg">
                                <span className="icon_wrapper"><i className="fa fa-quote-left"></i><p className="mt-2">Quotes</p></span>
                                <span className="conut_wrapper">
                                    {quatationData?.length}
                                </span>
                            </div>
                        </Link>
                        </div>
                        <div className="col-xxl-3 col-lg-6 col-md-4 col-sm-6"><Link to="/admin/clubmembershiplist">
                            <div className="shadow_box_wrapper green_bg">
                                <span className="icon_wrapper"><i className="fa fa-user-friends"></i><p className="mt-2">Club Memberships</p></span>
                                <span className="conut_wrapper">
                                    {clubMembership?.length}
                                </span>
                            </div>
                        </Link>
                        </div>
                        <div className="col-xxl-3 col-lg-6 col-md-4 col-sm-6 "><Link to="/admin/enquiry">
                            <div className="shadow_box_wrapper blue_bg">
                                <span className="icon_wrapper"><i className="fa fa-users"></i><p className="mt-2">Pending Requests</p></span>
                                <span className="conut_wrapper">
                                    {enquiryData?.length}
                                </span>
                            </div>
                        </Link>
                        </div>


                        <div className="row mb-5">
                            <div className="col-lg-12">
                                <DashboardLineChart />
                            </div>
                            {/* <div className="col-lg-6">
                                <GradientLineChart />
                            </div> */}
                        </div>
                        {/* <div className=" col-xxl-3 col-xl-3 col-lg-6 ">
                            <HotelSurvey />
                        </div>
                        <div className="col-xxl-6 col-lg-6">
                            <ReviewByLocation />
                        </div>
                        <div className="col-xxl-3 col-lg-6">
                            <LocationMapping />
                        </div> */}

                    </div>
                </div>
            </div>
        </AdminLayout>
    )
}

export default DashboardInnerPage;